import { skipToken } from "@reduxjs/toolkit/query";
import { useCurrentOrganization } from "Hooks";
import { useGetOrganizationQuery } from "../services/organizations.api";

const useCurrentOrganizationData = () => {
  const currentOrganization = useCurrentOrganization();
  const { data: currentOrganizationData } = useGetOrganizationQuery(
    currentOrganization
      ? {
          organizationId: currentOrganization.id,
        }
      : skipToken,
  );

  return currentOrganizationData;
};

export default useCurrentOrganizationData;
